export default __webpack_public_path__ + "static/media/18-days-voyage.293feb72.jpg";